function trimValue(el) {
    if (el.type === 'file' || el.type === 'select') {
        return; // Skip trimming for file inputs
    }
    if (el.value && typeof el.value === 'string') {
        el.value = el.value.trim();
        el.dispatchEvent(new Event('input')); // Notify Vue of the value change.
    }
}

export default trimValue;